import { RouterProvider } from "react-router-dom";
import { FirebaseProvider } from "./context/firebase-context";
import router from "./router";
function App() {
  return (
    <>
      <FirebaseProvider>
        <RouterProvider router={router} />
      </FirebaseProvider>
    </>
  );
}

export default App;
